/**
 * Dependencies.
 */
import { BaseModel, prop, propValidator, required } from '@prz-dp/services';

/**
 * Model `FormDeliverModel`.
 */
export class FormDeliverModel extends BaseModel {
  /**
   * Properties.
   */
  @required()
  clientName?: string;

  @propValidator('required', (value: string, formGroup) => {
    const isSignatureRequired: boolean =
      formGroup?.get('isSignatureRequired').value || false;

    return isSignatureRequired ? !!value : true;
  })
  deliverSignature: string;

  @prop()
  deliverAlert: string;

  @prop({ defaultValue: false, transient: true })
  isSignatureRequired: boolean;

  /**
   * Constructor.
   */
  constructor(data: Partial<FormDeliverModel>) {
    super(data);
  }
}
